import type { Competitor } from '../models/Competitor';

/**
 * The three AI companies (spec section 20). Each starts with the same cash as
 * the player and a distinct strategy:
 *  - Budget: cheap prices, low investment.
 *  - Premium: high prices, high service/reputation.
 *  - SmartPark: heavy technology investment.
 *
 * Returned via a factory so each new game gets a fresh, independent copy.
 */
export function createCompetitors(): Competitor[] {
  return [
    {
      id: 'budget',
      name: 'Budget Parking',
      strategy: 'budget',
      cash: 3_000_000,
      reputation: 45,
      priceTarget: 25,
      riskTolerance: 0.5,
      lots: [
        { id: 'budget-downtown', districtId: 'downtown', capacity: 60, price: 25, reputation: 45, upgrades: [] },
        { id: 'budget-shopping', districtId: 'shopping', capacity: 50, price: 25, reputation: 45, upgrades: [] },
        { id: 'budget-residential', districtId: 'residential', capacity: 40, price: 20, reputation: 45, upgrades: [] },
      ],
    },
    {
      id: 'premium',
      name: 'Premium Parking',
      strategy: 'premium',
      cash: 3_000_000,
      reputation: 82,
      priceTarget: 70,
      riskTolerance: 0.4,
      lots: [
        { id: 'premium-downtown', districtId: 'downtown', capacity: 35, price: 70, reputation: 82, upgrades: ['cctv'] },
        { id: 'premium-office', districtId: 'office', capacity: 30, price: 65, reputation: 82, upgrades: ['cctv'] },
      ],
    },
    {
      id: 'smartpark',
      name: 'SmartPark',
      strategy: 'smart',
      cash: 3_000_000,
      reputation: 72,
      priceTarget: 45,
      riskTolerance: 0.7,
      lots: [
        { id: 'smartpark-office', districtId: 'office', capacity: 50, price: 45, reputation: 72, upgrades: ['lpr', 'parking_sensor'] },
        { id: 'smartpark-shopping', districtId: 'shopping', capacity: 55, price: 45, reputation: 72, upgrades: ['parking_sensor'] },
        { id: 'smartpark-hospital', districtId: 'hospital', capacity: 45, price: 45, reputation: 72, upgrades: ['lpr'] },
      ],
    },
  ];
}
